export const state = {
  currentAppstream: getSavedState('currentAppstream'),
  isLoading: getSavedState('isLoading'),
}

export const mutations = {
  SET_APPSTREAM(state, newValue) {
    state.currentAppstream = newValue
    saveState('currentAppstream', newValue)
  },
  SET_LOADING(state, newValue) {
    state.isLoading = newValue
    saveState('isLoading', newValue)
  },
}

export const getters = {
  // Whether the user is currently logged in.
  selectedAppstream(state) {
    return state.currentAppstream
  },
  isLoading(state) {
    return state.isLoading
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    dispatch('validate')
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state }) {
    return null
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}
